import { Modal, Form, Input, Button, Upload, Space } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: any) => void;
}

export default function ProductVersionModal({ open, onClose, onSubmit }: Props) {

    const [form] = Form.useForm();
    const { t } = useTranslation();

    const [attributes, setAttributes] = useState<any[]>([
        { id: Date.now(), label: "", value: "" }
    ]);

    /* ADD ATTRIBUTE */

    const addAttribute = () => {
        setAttributes([
            ...attributes,
            { id: Date.now(), label: "", value: "" }
        ]);
    };

    /* DELETE ATTRIBUTE */

    const removeAttribute = (id: number) => {
        setAttributes(attributes.filter(a => a.id !== id));
    };

    /* SUBMIT */

    const handleOk = async () => {
        try {
            const values = await form.validateFields();

            onSubmit({
                ...values,
                attributes
            });

            form.resetFields();
            setAttributes([{ id: Date.now(), label: "", value: "" }]);
            onClose();
        } catch (error) {
            console.log("Xác thực thất bại:", error);
        }
    };

    return (

        <Modal
            title={t('products.add_version')}
            open={open}
            onCancel={onClose}
            onOk={handleOk}
            width={900}
        >

            <Form
                layout="vertical"
                form={form}
            >

                <div className="grid grid-cols-2 gap-x-4">

                    <Form.Item
                        label={t('products.col_name')}
                        name="name"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t('products.label_weight')}
                        name="weight"
                        initialValue={100}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_code')} name="code">
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_sale_price')} name="salePrice">
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_description')} name="description">
                        <Input.TextArea />
                    </Form.Item>

                    <Form.Item label={t('products.label_cost')} name="cost">
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_barcode')} name="barcode">
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_promo')} name="promo">
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_wholesale')} name="wholesale">
                        <Input />
                    </Form.Item>

                    <Form.Item label={t('products.label_unit')} name="unit">
                        <Input />
                    </Form.Item>

                </div>

                {/* HÌNH ẢNH */}

                <Upload listType="picture-card">

                    <div>
                        <PlusOutlined />
                        <div>{t('products.upload')}</div>
                    </div>

                </Upload>

                {/* THUỘC TÍNH */}

                <div className="mt-4">

                    <div className="flex gap-4 font-medium mb-2">

                        <span className="w-[200px]">{t('products.attr_label')}</span>
                        <span className="w-[200px]">{t('products.attr_value')}</span>
                        <span>{t('products.col_action')}</span>

                    </div>

                    {attributes.map((item, index) => (

                        <Space key={item.id} className="mb-2">

                            <Input
                                placeholder={t('products.attr_label')}
                                style={{ width: 200 }}
                                onChange={(e) => {
                                    const newData = [...attributes];
                                    newData[index].label = e.target.value;
                                    setAttributes(newData);
                                }}
                            />

                            <Input
                                placeholder={t('products.attr_value')}
                                style={{ width: 200 }}
                                onChange={(e) => {
                                    const newData = [...attributes];
                                    newData[index].value = e.target.value;
                                    setAttributes(newData);
                                }}
                            />

                            <Button
                                icon={<DeleteOutlined />}
                                onClick={() => removeAttribute(item.id)}
                            />

                        </Space>

                    ))}

                    <div>
                        <Button
                            icon={<PlusOutlined />}
                            onClick={addAttribute}
                            className="mt-2"
                        >
                            {t('products.add_attribute')}
                        </Button>
                    </div>
                </div>

            </Form>

        </Modal>
    );
}